import { render, staticRenderFns } from "./TheLeftMenu.vue?vue&type=template&id=154da194&scoped=true"
import script from "./TheLeftMenu.vue?vue&type=script&lang=js"
export * from "./TheLeftMenu.vue?vue&type=script&lang=js"
import style0 from "./TheLeftMenu.vue?vue&type=style&index=0&id=154da194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154da194",
  null
  
)

export default component.exports